<template>
    <div>
        <carousel/>
        <div>
            <h3>深度开发虚拟电商行业解决方案</h3>
            <p class="h3p">突破传统人工发货瓶颈，针对虚拟电商行业定制专属解决方案</p>
        </div>
        <div class="item">
            <div>
               <div>自动发卡解决方案</div>
                <p>微涟网帮助店主实现24小时无人值守自动发送激活码、二维码，省心省时省力。 全面提升店铺管理和运营能力，帮助您获客拉新，促进交易达成，开启智能新零售。</p>
                <p class="more">了解更多<span>→</span></p>
            </div>
            <div>
                <div>虚拟代充解决方案</div>
                <p>微涟网提供两种代充方式即手动代充和API代充，商家可以根据自己的需求个性化配置， 快速帮助客户充值。</p>
                <p class="more">了解更多<span>→</span></p>
            </div>
            <div>
                <div>营销推广解决方案</div>
                <p>代理改价、卡密拼团帮助您建立完成的销售体系，充分利用移动社交平台分享传播，快速提升商城交易量，为您打造超人气商城。</p>
                <p class="more">了解更多<span>→</span></p>
            </div>
        </div>
<!--        <div class="video">-->
<!--            <img src="../assets/videoCover.png" alt="">-->
<!--            <video src="https://ewei.shop/default/img/mp4/website.mp4"></video>-->
<!--        </div>-->
        <div>
            <h3>新零售商业模式</h3>
            <p  class="h3p">深度行业剖析，建立科学的卖货体系，轻松赚钱</p>
        </div>
        <div class="socialbg">
            <div class="sol-title">社交化营销模式更灵活，协助挖掘潜在客户，建立会员体系守住老用户</div>
            <div class="sol-left">
                <p :class="active[0]" @click="changeactive(0)">商城页面展示</p>
                <p :class="active[1]" @click="changeactive(1)">营销方案展示</p>
            </div>
            <div class="line">
                <div class="orange"  :style="'top:'+activetop*96+'px'"></div>
            </div>
            <router-view/>
        </div>
        <div class="zhineng">
            <h3>智能会员管理，让您更了解会员的消费习惯</h3>
            <ul>
                <li :class="lactive[0]" @click="changelactive(0)">会员管理</li>
                <li :class="lactive[1]" @click="changelactive(1)">会员营销</li>
                <li :class="lactive[2]" @click="changelactive(2)">会员标签</li>
            </ul>
            <div class="lactive">
                <img :src="'/site_static/img/'+lactimg[index]" alt="">
                <p>{{lactp[index]}}</p>
            </div>
        </div>
        <div class="keshi">
            <p>数据可视化展示，一目了然有利于您科学统计分析运筹帷幄</p>
            <ul>
                <li :class="mactive[0]" @click="changemactive(0)">
                    <mu-icon size="36" value="equalizer" color="grey50"></mu-icon>
                    <div>交易数据</div>
                </li>
                <li :class="mactive[1]" @click="changemactive(1)">
                    <mu-icon size="36" value="timeline" color="grey50"></mu-icon>
                    <div>商品数据</div>

                </li>
                <li :class="mactive[2]" @click="changemactive(2)">
                    <mu-icon size="36" value="face" color="grey50"></mu-icon>
                    <div>会员数据</div>
                </li>
            </ul>
            <div>
                <p>{{mactp[mindex]}}</p>
                <img :src="'/site_static/img/'+mactimg[mindex]" alt="">
            </div>
        </div>
        <div>
            <h3>装修店铺像搭积木一样简单</h3>
            <p style="font-size: 18px">专业设计师模板支持个性化设计，迅速掌握装修精髓打造人气商城</p>
        </div>
        <div class="zhuangxiu">
            <div>
                <video src="https://ewei.shop/default/img/mp4/gray.mp4" autoplay loop></video>
                <p>后台装修模块演示</p>
            </div>
            <div>
                <video src="https://ewei.shop/default/img/mp4/color.mp4" autoplay loop></video>
                <p>手机端装修展示</p>
            </div>
        </div>
        <div>
            <h3>一站式电商服务</h3>
            <p style="font-size: 18px">系统安全、稳定、可靠是您进军新零售社交分销电商的不二之选</p>
        </div>
        <div class="sell">
            <div>
                <div>
                    <img src="../assets/mall1.png" alt="">
                </div>
                <p class="tittle">我们的优势</p>
                <p class="sell-sub">我们可支持个性化功能开发定制服务，打造独一无二的电商商城</p>
                <p class="sell-sub">3年移动电商开发经验，用户使用量超过10万，累计为用户创造过亿收益</p>
            </div>
            <div>
                <div>
                    <img src="../assets/mall2.png" alt="">
                </div>
                <p class="tittle">我们的服务</p>
                <p class="sell-sub">以用户为中心，“用户至上”为基本服务原则，实时跟进用户需求</p>
                <p class="sell-sub">为您提供有针对性的解决方案，让您游刃有余的应对商城问题</p>
            </div>
            <div>
                <div>
                    <img src="../assets/mall3.png" alt="">
                </div>
                <p class="tittle">我们的特色</p>
                <p class="sell-sub">最新的底层框架技术，确保您在使用过程中更加流畅稳定</p>
                <p class="sell-sub">先进的前端技术，保证页面加载速度不卡顿，体验度更流畅</p>
            </div>
        </div>
<!--        <div>-->
<!--            <h3>新闻资讯</h3>-->
<!--            <ul class="news-tab">-->
<!--                <li :class="nactive[0]" @click="changenactive(0)">新闻动态</li>-->
<!--                <li :class="nactive[1]" @click="changenactive(1)">产品发布</li>-->
<!--            </ul>-->
<!--        </div>-->
<!--        <div class="news-item">-->
<!--            <ul v-if="item[0].length!=0">-->
<!--                <li v-for="(item,index) in item[nindex]">-->
<!--                    <div style=" height: 100%;margin-left: 20px;">{{item.time}}</div>-->
<!--                    <div style="margin: 0 20px; ">-->
<!--                        <p >{{item.tittle}}</p>-->
<!--                        <p>{{item.text}}</p>-->
<!--                    </div>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->
<!--        <div class="lmore">查看更多</div>-->
    </div>

</template>
<script>
    import carousel from '../components/carousel'
    export default {
        name: 'mid',
        components:{
            carousel
        },
        data(){
            return{
                active:['active','',''],
                activetop:0,
                ruto:['one','two','three'],
                lactive:['active','',''],
                lactimg:['member-manage.png','member-commission.png','member-label.png'],
                lactp:['全面掌握会员信息，轻松维护会员提高会员活性','全方位会员数据剖析，培养会员持续消费能力，实现会员价值最大化','系统自动生成会员消费标签，针对不同属性人群进行个性化营销'],
                index:0,
                mactp:['帮助您快速掌握商场用户的交易周期，深入洞察分析，为您提供一手商城交易数据支持。',
                    '智能商品数据监控，自动统计商品数据，为您提供精准、可靠、有效的商品销售数据。',
                    '细分会员分类，重视会员维护，帮助您不断发掘会员价值，促进会员新生，让会员产生更多价值。。'
                ],
                mactimg:['data3.png','data2.png','data1.png'],
                mindex:0,
                mactive:['active','',''],
                nactive:['active',''],
                nindex:0
                // item:[
                //     [
                //         {time:1,tittle:11,text:111},
                //         {time:2,tittle:22,text:222},
                //         {time:1,tittle:33,text:333},
                //         {time:1,tittle:44,text:444},
                //         {time:1,tittle:55,text:555},
                //         {time:1,tittle:66,text:666}
                //     ],
                //     [
                //         {time:'a',tittle:'aa',text:'aaa'},
                //         {time:'b',tittle:'bb',text:'bbb'},
                //         {time:'c',tittle:'cc',text:'ccc'},
                //         {time:'d',tittle:'dd',text:'ddd'},
                //         {time:'e',tittle:'ee',text:'eee'},
                //         {time:'f',tittle:'ff',text:'fff'}
                //     ]
                // ]
            }
        },
        methods:{
            changeactive(k){

                for (var i = 0 ;i<this.active.length;i++){
                    this.$set(this.active,i, '');
                }
                this.$set(this.active,k, 'active');
                this.activetop=k
                this.$router.push({name:this.ruto[k]})
            },
            changelactive(k){
                for (var i = 0 ;i<this.lactive.length;i++){
                    this.$set(this.lactive,i, '');
                }
                this.$set(this.lactive,k, 'active');
                this.index=k
            },
            changemactive(k){
                for (var i = 0 ;i<this.mactive.length;i++){
                    this.$set(this.mactive,i, '');
                }
                this.$set(this.mactive,k, 'active');
                this.mindex=k
            },
            changenactive(k){
                for (var i = 0 ;i<this.nactive.length;i++){
                    this.$set(this.nactive,i, '');
                }
                this.$set(this.nactive,k, 'active');
                this.nindex=k
            }

        }
    }
</script>
<style scoped>
    h3{
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 20px;
        font-weight: 500;
        margin-top: 50px;
    }
    .h3p{
        font-size: 18px;
        color: #5d6494;
        margin-bottom: 50px;
    }
    .zhengshu>div{
        width: 40%;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        background: #fff;
        max-height: 80%;
    }
    .zhengshu img{
        width: 100%;
        height: 100%;
    }
    .item{
        width: 1200px;
        margin: 0 auto;
        overflow: hidden;
    }
    .item>div{
        width: 380px;
        height: 320px;
        box-shadow: 0 0 18px 4px rgba(224,224,224,0.3);
        border-radius: 10px;
        padding: 38px 20px 0 38px;
        box-sizing: border-box;
        float: left;
    }
    .item>div>div{
        font-size: 20px;
        color: #3b426b;
        text-align: left;
    }
    .item>div>p{
        font-size: 14px;
        color: #7d88a2;
        line-height: 32px;
        margin-top: 10px;
        text-align: left;
    }
    .item .more{
        color: #FB6638;
        padding-top: 24px;
        font-size: 14px;
        align-items: center;
    }
    .more>span{
        padding-left: 10px;
    }
    .video img{
        margin-top: 50px;
        width: 25%;
    }
    .video>video{
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        top: 0;
        display: none;
    }
    .socialbg{
        height: 560px;
        width: 100%;
        background: url(../assets/socialbg.png) 100% 100% no-repeat;
        color: #fff;
        background-size: 100% 100%;
    }
    .sol-title{
        padding: 54px 0 68px 0;
        text-align: center;
        font-size: 22px;
    }
    .sol-left p{
        padding: 40px 20px;
        font-size: 16px;
        text-align: right;
        cursor: pointer;
    }
    .sol-left{
        color: #fff;
        width: 250px;
    }
    .line{
        width: 4px;
        background: #FFFFFF;
        position: relative;
        height: 192px;
        top: -220px;
        left: 275px;
    }
    .orange{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 96px;
        background: #FB6638;
        transition: all .2s;
    }
    .active{
        color: #fb6638 !important;
        border-color: #FB6638 !important;
    }
    .zhineng>h3{
        font-size: 22px;
        color: #FB6638;
        padding: 76px 0 44px 0;
        text-align: center;
    }
    .zhineng>ul>li{
        float: left;
        border-bottom: 2px solid transparent;
        margin-bottom: -1px;
        font-size: 16px;
        width: 360px;
        color: #3b426b;
        text-align: center;
        padding-bottom: 16px;
        cursor: pointer;
        list-style: none;
    }
    .zhineng>ul{
        border-bottom: 1px solid #d2d2d2;
        overflow: hidden;
        margin: 0 auto;
        width: 1120px;
    }
    .lactive{
        margin-top: 40px;
    }
    .lactive>p{
        font-size: 14px;
        color: #7b88a2;
        padding-bottom: 48px;
        text-align: center;
    }
    .keshi{
        background: url(../assets/data-view.png) no-repeat;
        width: 100%;
        padding: 70px 0 50px 0;
        text-align: center;
        color: #fff;
        background-size: 100% 100%;
        box-sizing: border-box;
        height: 600px;
    }
    .keshi>p{
        font-size: 22px;
        font-weight: 500;
        padding-bottom: 46px;
    }
    .keshi>ul{
        list-style: none;
        float: left;
    }
    .keshi>ul>li{
        width: 282px;
        height: 100px;
        background: rgba(255,255,255,0.04);
        border-radius: 4px;
        padding: 22px 0 20px 0;
        margin-bottom: 30px;
        box-sizing: border-box;
        margin-left: 154px;
        font-size: 16px;
        border: 1px solid transparent;
        cursor: pointer;
    }
    .keshi>div{
        margin-top: 43px;
        margin-right: 123px;
    }
    .zhuangxiu video{
        width: 326px;
        margin: 0 40px;
        height: 580px;
        border-radius: 6px;
        box-shadow: 2px 0px 20px #eee;
    }
    .zhuangxiu{
        overflow: hidden;
        width: 820px;
        margin: 0 auto;
    }
    .zhuangxiu p{
        padding-top: 20px;
        color: #7D88A2;
        font-size: 14px;
    }
    .zhuangxiu>div{
        float: left;
    }
    .sell{
        justify-content: space-between;
        margin: 16px auto 40px auto;
        align-items: center;
        height: 480px;
        width: 1200px;
        overflow: hidden;
    }
    .sell>div{
        width: 340px;
        height: 360px;
        box-shadow: 6px 6px 18px -2px rgba(224,224,224,0.5);
        padding: 0 30px;
        box-sizing: border-box;
        border-radius: 4px;
        transition: all .2s;
        float: left;
        margin: 0 30px;
        position: relative;
        top: 75px;
    }
    .sell>div:hover{
        width: 340px;
        height: 420px;
        background: linear-gradient(140deg,#ffbc2b,#f73c1d);
        top:50px
    }
    .sell>div:hover p{
        color: #ffffff;
    }
    .sell>div>div{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 158px;
    }
    .tittle{
        font-size: 20px;
        color: #3b426b;
        margin: 0;
        padding: 0;
        padding-bottom: 28px;
        text-align: center;
    }
    .sell-sub{
        font-size: 14px;
        color: #7D88A2;
        line-height: 26px;
        margin: 0;
        padding: 0;
        padding-bottom: 24px;
    }
    .news-tab{
        list-style: none;
        width: 390px;
        margin: 0 auto;
        overflow: hidden;
    }
    .news-tab>li{
        padding: 0 4px;
        border-bottom: 2px solid transparent;
        font-size: 20px;
        color: #5d6494;
        padding-bottom: 14px;
        margin: 0 42px;
        cursor: pointer;
        float: left;
    }
    .news-item{
        margin-top: 50px;
    }
    .news-item>ul{
        width: 1100px;
        margin: 0 auto;
        overflow: hidden;
    }
    .news-item>ul>li{
        width: 500px;
        height: 112px;
        box-shadow: 2px 2px 10px rgba(230,233,246,.5);
        margin-bottom: 28px;
        padding: 22px 16px 0 16px;
        box-sizing: border-box;
        float: left;
        margin: 0 15px;
        overflow: hidden;
    }
    .news-item>ul>li>div{
        float: left;
    }
    .lmore{
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 4px;
        background: #3b426b;
        margin: 10px auto 18px auto;
        cursor: pointer;
    }

    ul{
        list-style: none;
    }



</style>



// WEBPACK FOOTER //
// src/components/mid.vue